const steps = [
  ["Analysis", "We study the problem and the data before writing a line of code."],
  ["Design", "Architecture and interface, validated with you early."],
  ["Development", "Modern stacks, short iterations, working software every sprint."],
  ["Deployment", "We ship to production and keep it running as it grows."],
];

export function ProcessSection() {
  return (
    <section className="process" id="process">
      <div className="section-header">
        <div>
          <span className="eyebrow">03 — HOW WE WORK</span>
          <h2>From analysis to deployment</h2>
        </div>
      </div>
      <ol className="grid4">
        {steps.map(([title, text], i) => (
          <li key={title}>
            <span className="eyebrow">0{i + 1}</span>
            <h3>{title}</h3>
            <p>{text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
